import { defineLearningWorkspace } from '@frontend/pages/learning-workspace/siteLearningWorkspace';
import manifest from './workspace.json';
import lyceum from './lyceum.md';
import lyceumGuide from './lyceum-guide.md';
import lyceumPreamble from './lyceum-preamble.md';

export const learningWorkspace = defineLearningWorkspace(manifest, {
  lyceum,
}, {
  lyceum: lyceumGuide,
}, {
  lyceum: lyceumPreamble,
});
